import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Card, Form, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';



const WorksheetCheckList = (props) => {

    let lg = props.colLg ? props.colLg : 9;
    let md = props.colMd ? props.colMd : 12;
    const [values, setValues] = useState([]);
    const [masterOptions, setMasterOptions] = useState([]);

    useEffect(() => {
        if (masterOptions.length === 0) {
            setMasterOptions(props.masterQuestionOptions);
        }
    }, [])

    useEffect(() => {
        if (props.value?.length > 0) {
            setValues(props.value.split(':'));
        } else {
            setValues([])
        }
    }, [props.value])

    const onChange = (name) => {
        var setValues = values ? [...values] : [];

            if (setValues.includes(name)) {
                setValues.splice(setValues.indexOf(name), 1);
            } else {
                setValues.push(name);
            }
        setValues = setValues.sort();

        let event = { target: { name: props.name, value: setValues.join(':') } };

        props.onChangeInput(event);
    }

    const onBlur = () => {
        let event = { target: { name: props.name, value: values.join(':') } };
        props.onBlur(event);
    }

    const getCheckDisplayValue = (checked) => {
        if (checked === true) {
            return <FontAwesomeIcon icon={faCheckSquare} />
        } else {
            return <FontAwesomeIcon icon={faSquare} />
        }
    };

    if (props.print) {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Group as={Col} lg={lg} md={md}>
                    <Form.Label>{props.label}</Form.Label><br/>
                    {
                        masterOptions.map((opt, idx) => {
                            return (<div><Form.Label>{getCheckDisplayValue(values.includes(opt.optText))} {opt.optText}</Form.Label></div>)
                        })
                        //values.map((opt, idx) => {
                        //    return
                        //    <Form.Label>props.value.splice(':').includes(opt.optText) {opt.optText}</Form.Label>
                        //})
                    }
                </Form.Group>
            </Form.Group>
        );
    } else {
        return (

            <Form.Group as={Col} lg={lg} md={md} isInvalid={props.error} onBlur={() => onBlur() }>
                <Form.Label>{props.label}</Form.Label>
                {
                    masterOptions.map((opt, idx) => {
                        return <Form.Check type="checkbox"
                            label={opt.optText}
                            name={props.name + idx}
                            id={props.name + idx}
                            checked={values.includes(opt.optText)}
                            onChange={() => onChange(opt.optText)} />
                    })
                }
                <Form.Text className="text-muted">{props.description}</Form.Text>
                <Form.Control.Feedback type="invalid">
                    Initial and Revised values cannot be the same.
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export default WorksheetCheckList